// A cross-browser version of DOMMatrix, which is unfortunately only available
// as WebKitCSSMatrix on EdgeHTML. (The newer versions of Edge based on Chromium
// do support DOMMatrix directly, though.)
export type Matrix = DOMMatrix;
export const Matrix: typeof DOMMatrix = window.DOMMatrix ?? window.WebKitCSSMatrix;
